export const healthInsuranceEntryEndpoints = (builder) => ({
  getHealthInsuranceEntryList: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        filterColumn,
        filterValue,
        sortField,
        sortOrder,
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      if (searchTerm) params.searchTerm = searchTerm;
      if (filterColumn) params.filterColumn = filterColumn;
      if (filterValue) params.filterValue = filterValue;
      if (sortField) params.sortField = sortField;
      if (sortOrder) params.sortOrder = sortOrder;

      return {
        url: '/GeneralInsurance/get-health-insurance-entry-list',
        method: 'POST',
        body: params,
      };
    },
    providesTags: ['HealthInsuranceEntry'],
  }),
  getHealthInsuranceEntryById: builder.query({
    query: (id) => ({
      url: `/GeneralInsurance/get-health-insurance-entry/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'HealthInsuranceEntry', id }],
  }),
  saveHealthInsuranceEntry: builder.mutation({
    query: (data) => ({
      url: '/GeneralInsurance/save-health-insurance-entry',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['HealthInsuranceEntry'],
  }),
  deleteHealthInsuranceEntry: builder.mutation({
    query: (id) => ({
      url: `/GeneralInsurance/delete-health-insurance-entry/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['HealthInsuranceEntry'],
  }),
  bulkDeleteHealthInsuranceEntry: builder.mutation({
    query: (ids) => ({
      url: '/GeneralInsurance/bulk-delete-health-insurance-entry',
      method: 'DELETE',
      body: { ids },
    }),
    invalidatesTags: ['HealthInsuranceEntry'],
  }),
  checkHealthPolicyNumberExists: builder.query({
    query: ({ policyNumber, insurerId, entryId }) => ({
      url: `/GeneralInsurance/check-health-policy-exists`,
      method: 'GET',
      params: { policyNumber, insurerId, entryId }
    }),
  }),
  searchPolicyByNo: builder.query({
    query: (args) => {
      const params = typeof args === 'string' ? { policyNo: args } : args;
      return {
        url: `/GeneralInsurance/search-policy`,
        method: 'GET',
        params
      };
    },
  }),
  verifyAdminPassword: builder.mutation({
    query: (password) => ({
      url: '/GeneralInsurance/verify-admin-password',
      method: 'POST',
      body: { password }
    })
  }),
});

